// Angular Files
import { Injectable } from '@angular/core';


// Other External Files
import { Observable } from 'rxjs';

// Teller Online Files
import { AuthService } from './auth.service';

// Teller Online Library Files
import { TellerOnlineAppService } from 'teller-online-libraries/core';
import { TellerOnlineMessageService } from 'teller-online-libraries/shared';

@Injectable({
    providedIn: 'root'
})
export class PendingChangesGuardService {

    constructor(
        private messageService: TellerOnlineMessageService,
        private appService: TellerOnlineAppService,
        private authService: AuthService
    ) { }

    async canDeactivate(featureComponent: FeatureCanDeactivate): Promise<boolean> {
        // Determine which page we're on to decide if we need special checks
        const isProfilePage = this.appService.currentUrl.startsWith("/profile");

        // Allow navigation without prompting if:
        // - No component provided, or
        // - On profile page but user is not authenticated (i.e. session expired, no point asking about unsaved changes)
        if (!featureComponent || (isProfilePage && !this.authService.authDetails)) {
            return true;
        }

        let featurePrompt = {
            message: 'You have unsaved changes. Press "No" to go back and save these changes, or "Yes" to lose these changes.',
            title: 'Lose Unsaved Changes?'
        }

        let featureDeactivate = featureComponent.canDeactivate(featurePrompt);
        let canDeactivate: boolean;
        // if there are no pending changes, just allow deactivation; else confirm first
        if (featureDeactivate) {
            canDeactivate = true;
        } else {
            // Turn off loading before we prompt or the prompt won't work
            this.appService.finishLoading();
            // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
            // when navigating away from your angular app, the browser will show a generic warning message
            // see http://stackoverflow.com/a/42207299/7307355
            canDeactivate = await this.messageService.prompt(featurePrompt.message, featurePrompt.title);
        }
        // turn loading back on if we're leaving
        if (canDeactivate) this.appService.triggerLoading("Loading...");

        // If we can deactivate, call the component's cleanup method (if it exists)
        if (canDeactivate && featureComponent.onDeactivate) {
            await featureComponent.onDeactivate();
        }

        return canDeactivate;
    }
}
export interface FeatureCanDeactivate {
    canDeactivate: (featurePrompt: { message: string, title: string }) => boolean | Observable<boolean>;
    /** Optional cleanup method called when deactivation is allowed */
    onDeactivate?: () => Promise<void> | void;
}
